import React, { useEffect, useState } from 'react'
import nbrApi from '../../../services/nbrApi'
import { Tab, Tabs, Table } from 'react-bootstrap';
import ActiveClockinsTable from '../../components/ResourceStats/ActiveClockinsTable'
import ActiveLoginsTable from '../../components/ResourceStats/ActiveLoginsTable'
import HistoricalClockinsTable from '../../components/ResourceStats/HistoricalClockinsTable'
import HistoricalLoginsTable from '../../components/ResourceStats/HistoricalLoginsTable'
import ResourceDataDisplay from './ResourceDataDisplay';

function ResourceStatsIndex() {
    const [data, setData] = useState({})
    const [activeTab, setActiveTab] = useState('active_time_segments');
    const selectedLoginData = JSON.parse(localStorage.getItem('selectedLoginData')) || {}
    const tabs = [
        { eventKey: "active_time_segments", title: "Active Time Segments" },
        { eventKey: "active_logins", title: "Active Logins" },
        { eventKey: "active_clockins", title: "Active Clockins" },
        { eventKey: "historical_clockins", title: "Historical Clockins" },
        { eventKey: "historical_logins", title: "Historical Logins" },
    ]
    const handleTabSelect = (tab) => {
        setActiveTab(tab);
    };

    const renderTable = () => {
        switch (activeTab) {
            case 'active_time_segments':
                return <ResourceDataDisplay data={data} />
            case 'active_logins':
                return <ActiveLoginsTable data={data?.active_logins} />;
            case 'active_clockins':
                return <ActiveClockinsTable data={data?.active_clockins} />;
            case 'historical_clockins':
                return <HistoricalClockinsTable data={data?.historical_clockins} />;
            case 'historical_logins':
                return <HistoricalLoginsTable data={data?.historical_logins} />;
            default:
                return null;
        }
    };

    // get data
    const getData = async () => {
        try {
            const res = await nbrApi.post('/getresourcestatus', { properties_id: selectedLoginData?.properties_id });

            if (res?.data) {
                setData(res.data);
            } else {
                setData({});
            }
        } catch (error) {
            setData({});
        }
    };

    // init
    useEffect(() => {
        getData()
    }, [activeTab])

    useEffect(() => {
        const intervalId = setInterval(() => {
            getData();
        }, 5000);
        return () => clearInterval(intervalId);
    }, [activeTab]);

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Resource Stats</h4>
                    </div>

                    <div className="card-body">
                        {!data &&
                            <p className='alert alert-primary fw-bold'>No Data available !</p>}

                        {/* if data available */}
                        {activeTab && (
                            <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
                                {tabs.map((tab) => (
                                    <Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
                                        {renderTable()}
                                    </Tab>
                                ))}
                            </Tabs>
                        )}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResourceStatsIndex